import _ from 'lodash';
import api from '../../../api';
import helper from '../../../helper';

// const addStratCatColumns = (lpData, lku) => _(lpData).map((o) => {
//   const stratCatCols = { sc1: lku.Stratification[o.s1].parent };
//   if (o.s2) {
//     _.assign(stratCatCols, { sc2: lku.Stratification[o.s2].parent });
//   }
//   return _.assign(_.clone(o), stratCatCols);
// }).value();

// const addMultistratRowsAndStratCatColumns = (questionData, lku) => {
//   const level2rows = _(questionData).filter(o => o.s2)
//     .map((o) => {
//       const s1 = o.s1;
//       const s2 = o.s2;
//       return _.assign(_.clone(o), {
//       // sc1: lku.Stratification[s2].parent,
//         s1: s2,
//         // sc2: lku.Stratification[s1].parent,
//         s2: s1,
//       });
//     }).value();
//   const combinedRows = questionData.concat(level2rows);
//   const combinedRowsWithStratCatColumns = addStratCatColumns(combinedRows, lku);

//   return _(combinedRowsWithStratCatColumns).orderBy(['qi', 'yr', 'sc1', 's1', 'sc2', 's2', 'rs', 'dvt']).value();
// };

const actions = {
  getQuestionDataAndSetIndicatorId({ commit, rootState }, indicatorId) {
    if (indicatorId) {
      commit('setLoadingQuestionData', true);
      api.get(`LPQuestionLink/${indicatorId}`)
        .then((response) => {
          // console.log('got LPQuestionLink', performance.now());
          let questionData;
          const dataErrors =
            helper.checkForMissingLookupIdsFromRawQuestionData(
              rootState.lku,
              rootState.dataTypes, response.data,
            );
          if (dataErrors.length) {
            dataErrors.forEach((error) => {
              commit('addDataError', error, { root: true });
            });
            questionData = [];
          } else {
            questionData = helper.addMultistratRowsAndStratCatColumns(response.data, rootState.lku);
          }
          commit('setIndicatorId', indicatorId);
          commit('setQuestionData', questionData);
          commit('setIndicatorChanged', true);
          commit('setLoadingQuestionData', false);
        })
        .catch((err) => {
          commit('setQuestionData', false);
          commit('addApiError', err, { root: true });
        });
    } else {
      commit('setIndicatorId', indicatorId);
      commit('setQuestionData', []);
    }
  },
  getLPData({
    commit, getters, rootState,
  }, payload) {
    const { filterObj, router } = payload;
    const parmsObjEncoded = _.map(
      filterObj,
      (value, key) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    );

    let lpData;
    const queryString = parmsObjEncoded.join('&');
    // console.log(queryString);
    commit('setLoadingReportDataIds', true);
    commit('setLoadingLPData', true);
    api.get(`LPData?${queryString}`)
      .then((response) => {
        // console.log('got reportDataIds', performance.now());
        const LPDataMissingLookupErrors =
          helper.checkForMissingLookupIdsInLPData(rootState.lku, response.data);
        if (LPDataMissingLookupErrors.length > 0) {
          LPDataMissingLookupErrors.forEach((err) => {
            commit('addDataError', err);
          });
        }
        // console.log('completed checkForMissingLookupIdsInReportDataIds',
        //   performance.now());
        lpData = [];
        lpData = helper.addStratCatColumns(response.data, rootState.lku);
        commit('setLPData', lpData);
        commit('setStratFilters', filterObj);
        commit('setLoadingLPData', false);
        getters.setBrowserUrlBarToReflectCurrentLPState(router);
      })
      .catch((err) => {
        commit('setLoadingLPData', false);
        commit('addApiError', err, { root: true });
      });
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/LP/actions.js